import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/organizations/__root')({
  component: AdminOrganizationsRootRoute,
});

function AdminOrganizationsRootRoute() {
  return <Outlet />;
}
